import { render, staticRenderFns } from "./AuditLogButton.vue?vue&type=template&id=0c824508&scoped=true"
import script from "./AuditLogButton.vue?vue&type=script&lang=js"
export * from "./AuditLogButton.vue?vue&type=script&lang=js"
import style0 from "./AuditLogButton.vue?vue&type=style&index=0&id=0c824508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c824508",
  null
  
)

export default component.exports